import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import css from './menu.scss';
import lorem from '../../../utils/lorem';

import Profile from './profile/profile';

import { generateURL, accountRoute } from '../../../routes';
import * as MenuType from '../../../constants/types';

export default class GlobalNavMenu extends Component {
	static propTypes = {
		menuActive: PropTypes.bool.isRequired,
		mainMenu: PropTypes.object.isRequired,
		subMenu: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.state = {
			sideMenuHeight: 0,
			activeMenuTop: 0,
			headerHeight: 60,
		};

		this.setState(this.state);
	}

	componentDidUpdate() {
		let sideMenu = this.refs.sidemenu;

		if (sideMenu) {
			let height = sideMenu.getBoundingClientRect().height;
			let header = document.querySelector('header.header-main');

			if (this.state.sideMenuHeight !== height) {
				if (header) {
					this.state.headerHeight = header.getBoundingClientRect().height;
				}

				this.state.sideMenuHeight = height;
				this.setState(this.state);
			}
		}
	}

	render() {
		let menulistClass = 'mainmenu__nav__menu-link-list';
		let profileBoxClass = 'mainmenu__nav__bottom span5 span10-tablet span14-mobile';

		if (this.isMenuLinkActive()) {
			menulistClass += ' mainmenu__nav__menu-link-list--active';
			profileBoxClass += ' mainmenu__nav__bottom--fade';
		}

		let flexerClass = 'mainmenu-flexer';
		if (this.props.selectedMenu) {
			flexerClass += ' ' + flexerClass + '--active';
		}

		return (
			<div className='mainmenu-container'>
				<div className={flexerClass}>
					<div className='mainmenu__nav'>
						<div className='push2 push1-tablet mainmenu__nav__top'>
							<ul className={menulistClass}>
								{this.buildMenu(this.props.mainMenu, true)}
							</ul>
							<ul className='mainmenu__nav__social-link-list'>
								{this.buildMenu(this.props.socialLinks, false)}
							</ul>
						</div>
						<div className={profileBoxClass}>
							<div className='push2 push1-tablet'>
								<Profile {...this.props.userActions} {...this.props.menuActions} user={this.props.user} dispatch={this.props.dispatch} menuActive={this.props.menuActive} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	toggleMenu() {
		this.props.menuActions.toggleMenu();
	}

	isMenuLinkActive() {
		if (this.props.selectedMenu) {
			let mmItems = this.props.mainMenu.items;
			for (var i = 0; i < mmItems.length; i++) {
				if (this.props.selectedMenu === mmItems[i]) {
					return true;
				}
			}
		}

		return false;
	}

	buildMenu(menu, hasSubmenu, parent = false) {
		//if (parent) {
		//	menu = {...menu};
		//	parent.appendClass = 'category-header';
		//	menu.items.unshift(parent);
		//}

		if (menu && menu.items && menu.items.length > 0) {
			return menu.items.map((link, i) => {
				if (!link.name || link.name.length === 0) {
					return false;
				}
				return this.renderMenuLink(link, i, (hasSubmenu && link.items && link.items.length > 0), hasSubmenu, parent);
			});
		}
	}

	renderMenuLink(link, i, isCollection, hasSubmenu, parent) {
		let isHttpLink = (/(http|https)/.test(link.url));
		let liClass = (this.props.selectedMenu === link) ? 'is-active' : '';
		liClass += (isCollection) ? ' collection' : '';

		let linkString = `${link.name}`;

		if (typeof link.appendClass === 'string') {
			liClass += ' ' + link.appendClass;
		}

		let url = link.slug;
		if (parent && parent.slug && link.type === 'templates') {
			url = parent.slug + '/' + url;
		}

		if (link.type === 'external') {
			return (
				<li key={link.id + i} className={liClass}>
					<a href={link.url} title={link.title || ''}>{link.name}<span></span></a>
				</li>
			);
		} else {
			return (
				<li key={link.slug + i} className={liClass}>
					{((
						(!link.items && !isHttpLink) ||
						(link.type !== MenuType.TYPE_NONE && link.type !== MenuType.TYPE_CONTAINER && link.type !== MenuType.TYPE_EDITORIAL_LIST)
					) &&
						<Link to={generateURL(link.type, url)} title={link.title || ''} onClick={() => { this.props.menuActions.setActiveMenu(link); }}>
							{linkString}
						</Link>
					) || (
						<a
							href={isHttpLink ? link.url : 'javascript:void(0);'}
							title={link.title || ''}
							onClick={
								(e) => {
									e.preventDefault();
									this.state.activeMenuTop = e.target.getBoundingClientRect().top;
									this.props.menuActions.setActiveMenu(link);
								}
							}
						>
							{linkString}
							<span></span>
						</a>
					)}
					{(link.items && link.items.length > 0 && hasSubmenu) &&
						<ul>
							{this.buildMenu(link, false, link)}
						</ul>
					}
				</li>
			);
		}
	}


}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/menu/menu.js
 **/